type Props = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
};

export default function SectionHeader({ eyebrow, title, subtitle }: Props) {
  return (
    <div className="mb-8 max-w-2xl">
      {eyebrow && (
        <div className="mb-2 inline-flex rounded-full border border-blue-500/40 bg-blue-500/10 px-3 py-1 text-[11px] font-medium uppercase tracking-wider text-blue-200">
          {eyebrow}
        </div>
      )}
      <h2 className="text-2xl font-semibold sm:text-3xl">{title}</h2>
      {subtitle && (
        <p className="mt-2 text-sm text-slate-300">{subtitle}</p>
      )}
    </div>
  );
}
